import {
    PortfolioSelectionDependencyType,
    WidgetStreamStreamingConfig,
} from 'widgets/streaming/WidgetStreamConfig';
import { createIntraDayProfileStreamRequest } from 'widgets/intraDayProfile/store/data/IntraDayProfileStreamRequest';
import { IntraDayProfileStreamRequest } from 'communication/types/intraDayProfile/IntraDayProfileStreamRequest';
import { IntraDayProfileElement } from 'communication/types/intraDayProfile/IntraDayProfileElement';
import { buildIntraDayProfileStreamSlice } from 'widgets/intraDayProfile/store/data/streamSlice';
import { ActionsDispatcher } from 'store/ActionsDispatcher';
import { createUpdateWidgetComponentStateAction } from 'widgets/store/component/actions';
import { PortfolioReturnsComponentState } from 'widgets/portfolioReturns/store/component/PortfolioReturnsComponentState';
import { WidgetType } from 'widgets/WidgetType';
import State from 'store/State';
import { getIntradayProfileMarketDataRequests } from 'widgets/intraDayProfile/marketData';
const { actions, selectors } = buildIntraDayProfileStreamSlice();

export const streamConfig: WidgetStreamStreamingConfig<
    IntraDayProfileStreamRequest,
    IntraDayProfileElement
> = {
    streamType: 'StreamingStream',
    configType: 'PortfolioSelectionDependentWidgetStreamConfig',
    startChannelDestination: 'startIntradayProfilesStream',
    createPayload: createIntraDayProfileStreamRequest,
    createMarketDataRequests: getIntradayProfileMarketDataRequests,
    selectionDependencyType:
        PortfolioSelectionDependencyType.AtLeastOneSymbolQuantity,
    selectWidgetStreamKey: selectors.selectStreamKey,
    clearWidgetStreamData: actions.createClearStreamDataAction,
    subscriptions: { widgetConfig: true },
    onStartStreaming,
};

function onStartStreaming(
    state: State,
    dispatcher: ActionsDispatcher,
    payload: unknown,
    widgetKey: string
) {
    const request = payload as IntraDayProfileStreamRequest;
    const requestSymbology = request.symbology;
    const action =
        createUpdateWidgetComponentStateAction<PortfolioReturnsComponentState>(
            WidgetType.INTRA_DAY_PROFILE
        )(widgetKey, { requestSymbology });
    dispatcher.dispatch(action);
}
